import { render, staticRenderFns } from "./ArticleSection.vue?vue&type=template&id=8775993a&"
import script from "./ArticleSection.vue?vue&type=script&lang=ts&"
export * from "./ArticleSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports